var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookNoCircleIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon facebook-no-circle-icon",
    viewBox: "0 0 10 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.925 0l2.736.003c.187 0 .339.147.339.327v3.322c0 .18-.152.348-.34.348H7.88c-1.004 0-1.187.354-1.187 1.094V6h2.124c.19 0 .34.193.34.38v3.33c0 .18-.153.29-.34.29H6.693v5.674c0 .18-.152.326-.34.326H2.852a.333.333 0 01-.34-.326V10H.34C.152 10 0 9.89 0 9.71V6.38C0 6.2.152 6 .34 6h2.172V3.938C2.499 1.6 4.165 0 6.925 0zm-.001 1l-.221.004c-2.043.075-3.2 1.19-3.19 2.934V7H.999v2h2.512v6h2.18V9h2.464V7H5.694V5.094C5.694 3.734 6.388 3 7.881 3h1.12V1.003z"
  })));
}

export default SvgFacebookNoCircleIconSv;